import { render, staticRenderFns } from "./blog-crashing-after-update.vue?vue&type=template&id=06fdd824&scoped=true"
import script from "./blog-crashing-after-update.vue?vue&type=script&lang=js"
export * from "./blog-crashing-after-update.vue?vue&type=script&lang=js"
import style0 from "./blog-crashing-after-update.vue?vue&type=style&index=0&id=06fdd824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fdd824",
  null
  
)

export default component.exports